import { render, staticRenderFns } from "./move.vue.html?vue&type=template&id=24ff0967"
import script from "./move.controller?vue&type=script&lang=js&external"
export * from "./move.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports